<template>
  <div>
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @changeMethod="changeMethod"
    ></SiruiSearch>
    <!--内容区域-->
    <!-- :showFooter="1 == 1"
        :footerMethod="footerTotalCols ? footerMethodTotal : null" -->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="false"
        rowKey="invoiceNo"
        :cellStyle="cellStyle"
        :cellClick="cellClick"
        @handleSizeChange="getTableData"
        @handleCurrentChange="getTableData"
      >
        <vxe-table-column
          v-for="(item, index) in columnListDefault"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :formatter="item.formatter"
          :field="item.field"
          :title="item.title"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else-if="item.field == 'isGenerateSales'">
              {{ scope.row[item.field] ? '是' : '否' }}
            </span>
            <!-- <span v-else-if="item.field == 'shipComplete'"> 否 </span> -->
            <span v-else-if="item.field == 'contractValidStart'">
              <template v-if="scope.row['contractValidStart'] && scope.row['contractValidEnd']">
                {{ scope.row['contractValidStart'] }}至{{ scope.row['contractValidEnd'] }}
              </template>
            </span>
            <span v-else-if="item.field == 'liquidatedDamagesType'">
              {{ getValueName(item.field, scope.row[item.field]) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>

<script>
  import { searchCells, defaultColumns } from './index.js';
  import tableMixins from '@/common/mixins/table.js';
  import { filterEmpty } from '@/common/js/util';
  export default {
    name: 'OverdueList',
    mixins: [tableMixins],
    data() {
      return {
        // footerTotalCols: {
        //   amount: ['contractTotalAmount'],
        //   quantity: ['productQuantity'],
        // }, //底部合计列-字段名，数字类型金额amount，数量quantity等）判断小数点
        query: {
          contractBusinessDepartmentNo: null,
          contractNoLike: null,
          customerNo: null,
          platformCompanyCode: null,
          projectInitiationNo: null,
        },
      };
    },
    watch: {},
    computed: {
      searchColumns() {
        return searchCells(this);
      },
      columnListDefault() {
        return defaultColumns;
      },
    },
    mounted() {
      this.resetQuery();
      this.getTableData();
    },
    methods: {
      resetQuery() {
        this.query = {
          contractBusinessDepartmentNo: this.userInfo.userInfo.departmentCode,
          contractNoLike: null,
          customerNo: null,
          platformCompanyCode: this.userInfo.userInfo.companyCode,
          projectInitiationNo: null,
        };
      },
      resetBtnClick() {
        this.resetQuery();
        this.getTableData();
      },
      searchBtnClick() {
        this.getTableData();
      },
      cellStyle({ column }) {
        if (column.property == 'contractNo') {
          return {
            color: '#009fcc',
          };
        }
      },
      cellClick(val) {
        if (val.column?.property == 'contractNo') {
          this.toContractDetail(val.row);
        }
      },
      toContractDetail(rowData) {
        rowData.contractCategory;
        rowData.contractNo;
        let path;
        if (rowData.contractCategory == 'purchase') {
          path = {
            path: '/salePurchase/purchaseContractEdit',
            name: 'purchaseContractEdit',
            meta: {
              keepAlive: true,
              title: '采购合同编辑',
            },
            query: {
              id: rowData.contractId,
              type: 'CG01',
              contractNo: rowData.contractNo,
              isEdit: false,
              contractCategory: 'purchase',
            },
          };
        } else {
          path = {
            path: '/salePurchase/saleContractEdit',
            name: 'saleContractEdit',
            meta: {
              keepAlive: true,
              title: '销售合同编辑',
            },
            query: {
              id: rowData.contractId,
              type: 'CG04',
              contractNo: rowData.contractNo,
              contractCategory: 'sales',
              isEdit: false,
            },
          };
        }

        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      getButtonList() {
        this.getButtons().then((e) => {
          let list = [];
          if (e && e.length != 0) {
            for (let item of e) {
              if (item.label != '导入' && item.label != '正本收集' && item.label != '正本归档') {
                list.push(item);
              }
            }
          }
          this.menuButtonList = list;
        });
      },

      // 表单中的数据切换
      async changeMethod({ prop, val }) {
        console.log(prop, val, '修改');
        if (prop == 'platformCompanyCode') {
          console.log(prop, val, '修改');
        } else if (prop == 'contractBusinessDepartmentNo') {
          this.query.contractBusinessDepartmentNo = val.createDepartmentCode;
        } else if (prop == 'projectInitiationNo') {
          this.query.projectInitiationNo = val[0].projectInitiationNo;
        } else if (prop == 'contractNoLike') {
          this.query.contractNoLike = val[0].contractNo;
        } else if (prop == 'customerNo') {
          let item = val[0];
          if (item) {
            this.query.customerNo = item.partnerCode;
          }
        }
      },
      async getTableData() {
        let params = { ...this.query };
        params.pageSize = this.$refs.siruiTable.page.pageSize;
        params.pageNum = this.$refs.siruiTable.page.pageNum;
        let { data } = await this.$axios.post(
          '/financial/statistic/overdue/page',
          filterEmpty(params)
        );

        if (data.code == 0) {
          let info = data.data.records;
          if (this.$refs.siruiTable) {
            this.$refs.siruiTable.setPageTotal(data.data.total);
          }
          let result = [];
          if (info.length != 0) {
            info.forEach((item) => {
              if (item.invoiceInfoList && item.invoiceInfoList.length != 0) {
                item.invoiceInfoList.forEach((invoice) => {
                  let combined = Object.assign(item, invoice);
                  result.push(combined);
                });
              } else {
                result.push(item);
              }
            });
          }
          this.tableData = result;
        }
      },

      getValueName(field, value) {
        if (!value || value == '') {
          return '';
        }
        if (field == 'liquidatedDamagesType') {
          if (value == 'FIXED') {
            return '按固定值';
          } else if (value == 'RATE') {
            return '按利率';
          }
        }
        return '';
      },
    },
    components: {},
  };
</script>

<style></style>
